import { render, staticRenderFns } from "./AltaAlumnos.vue?vue&type=template&id=313354e6&"
import script from "./AltaAlumnos.vue?vue&type=script&lang=js&"
export * from "./AltaAlumnos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports